import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../../app.constants';

import { Loader } from '@interfaces';
import { LoaderService } from '@core';

@Component({
    selector: 'app-spinner-loader',
    templateUrl: './spinner-loader.component.html',
    styleUrls: ['./spinner-loader.component.scss'],
    standalone: false
})
export class SpinnerLoaderComponent implements OnInit, OnDestroy {
  private static readonly className = 'LoaderComponent';

  private subscription: Subscription = new Subscription();
  public show = false;
  public message = AppConstants.LOADER.DEFAULT_MESSAGE;

  /**
   * @param  LoaderService loaderService
   */
  constructor(private readonly loaderService: LoaderService) { }

  public ngOnInit(): void {
    this.subscription = this.loaderService.loader.subscribe((state: Loader) => {
      this.message = state.message;
      this.show = state.show;
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


}
